import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import InfoPill from 'components/shared/InfoPill';
import { useMemo } from 'react';
import { formatNameToAprLabel, formatTermsFromRates } from './helpers';

export interface LayoutSidebarFinanceRatesFinancePillProps {
  name: string;
  rates: FinanceRate[];
  isLoading: boolean;
}

const LayoutSidebarFinanceRatesFinancePill: React.FunctionComponent<LayoutSidebarFinanceRatesFinancePillProps> =
  function ({ name, rates, isLoading }) {
    const aprLabel = useMemo(() => formatNameToAprLabel(name), [name]);
    const terms = useMemo(() => formatTermsFromRates(rates), [rates]);
    return (
      <InfoPill
        id={name}
        content={`${aprLabel} - ${terms}`}
        isLoading={isLoading}
        skeletonProps={{
          width: 150,
        }}
      />
    );
  };

export default LayoutSidebarFinanceRatesFinancePill;
